import PerfectScrollbarBase from "./base/PerfectScrollbarBase";
/**
 *
 * Perfect Scrollbar React Component
 *
 */
export default PerfectScrollbarBase;
